<options-select
  [availableOptions]="currencyList"
  [selectedOptions]="[selectedCurrency]"
  (selectValue)="selectedCurrency = $event; selectCurrency.emit({currencyItem: $event, selectedByKeyboard: false})"
  (selectValueWithKeyboard)="selectedCurrency = $event; selectCurrency.emit({currencyItem: $event, selectedByKeyboard: true})">
</options-select>
